import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { DataService_Attendance } from "./shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-attendance",
	templateUrl: "./attendance.component.html",
	styleUrls: ["./attendance.component.css"],
})
export class AttendanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private AttendanceTempService: DataService_Attendance
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		//	Set DateType Selector
		//
		this.lstDataType = [
			{ ID: 1, Desc: "Attendance" },
			{ ID: 2, Desc: "Timescan" },
		];

		this.SelectedDataType = this.lstDataType[0];

		//
		//	Init Person Selector
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.SchoolID = this.SelectedPerson.SchoolID;
			this.loadStats();
			// this.onRefresh();
		});
	}

	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	user: any;

	SelectedAttendance: any = null;
	SchoolID: any = 0;

	SelectedDataType: any;
	lstDataType: any = [];

	////////////////////
	// Person Selector
	////////////////////

	private subscriptionPersonSelect: Subscription;
	public SelectedPerson: any;

	////////////////////

	//////////////////////
	//Options Selector
	//////////////////////

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	ErrorMessage: any = "";

	LoadingData: any = false;

	//Stats
	Stats: any;

	PresentCount: any = 0;
	PresentPCT: any = 0;
	PartialPresent: any = 0;
	PartialPresentPCT: any = 0;
	AbsenceCount: any = 0;
	AbsenceCountPCT: any = 0;
	ExcusedAbsenceCount: any = 0;
	ExcusedAbsenceCountPCT: any = 0;
	TardyCount: any = 0;
	TardyCountPCT: any = 0;
	ExcusedTardyCount: any = 0;
	ExcusedTardyCountPCT: any = 0;
	TotalDays: any = 0;
	MissingDays: any = 0;
	MissingDaysPCT: any = 0;
	EnteredDays: any = 0;
	EnteredDaysPCT: any = 0;
	//////////////////////

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////
	loadStats() {
		this.LoadingData = true;

		this.SelectedAttendance = null;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.LoadingData = false;

			return;
		}

		this.ResetStats();

		var result = this.AttendanceTempService.AttendanceStatsInfoGetList(this.SelectedPerson.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.Stats = response[0];

				this.PresentCount = this.Stats.PresentCount;
				this.PresentPCT = this.Stats.PresentPCT;
				this.PartialPresent = this.Stats.PartialPresent;
				this.PartialPresentPCT = this.Stats.PartialPresentPCT;
				this.AbsenceCount = this.Stats.AbsenceCount;
				this.AbsenceCountPCT = this.Stats.AbsenceCountPCT;
				this.ExcusedAbsenceCount = this.Stats.ExcusedAbsenceCount;
				this.ExcusedAbsenceCountPCT = this.Stats.ExcusedAbsenceCountPCT;
				this.TardyCount = this.Stats.TardyCount;
				this.TardyCountPCT = this.Stats.TardyCountPCT;
				this.ExcusedTardyCount = this.Stats.ExcusedTardyCount;
				this.ExcusedTardyCountPCT = this.Stats.ExcusedTardyCountPCT;
				this.TotalDays = this.Stats.TotalDays;
				this.MissingDays = this.Stats.MissingDays;
				this.MissingDaysPCT = this.Stats.MissingDaysPCT;
				this.EnteredDays = this.Stats.EnteredDays;
				this.EnteredDaysPCT = this.Stats.EnteredDaysPCT;

				this.LoadingData = false;
			},
			(error) => {}
		);
	}

	ResetStats() {
		this.PresentCount = 0;
		this.PresentPCT = 0;
		this.PartialPresent = 0;
		this.PartialPresentPCT = 0;
		this.AbsenceCount = 0;
		this.AbsenceCountPCT = 0;
		this.ExcusedAbsenceCount = 0;
		this.ExcusedAbsenceCountPCT = 0;
		this.TardyCount = 0;
		this.TardyCountPCT = 0;
		this.ExcusedTardyCount = 0;
		this.ExcusedTardyCountPCT = 0;
		this.TotalDays = 0;
		this.MissingDays = 0;
		this.MissingDaysPCT = 0;
		this.EnteredDays = 0;
		this.EnteredDaysPCT = 0;
	}
	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////
	onAttendanceSelected(val) {
		this.SelectedAttendance = val;
	}

	onAttendanceChanged() {
		this.loadStats();
	}

	onDataTypeChange(val) {
		this.SelectedDataType = val;

		//Update values
	}

	onStartDateChange(val) {
		this.StartDate = val;

		//Update values
		this.loadStats();
	}
	onEndDateChange(val) {
		this.EndDate = val;

		//Update values
		this.loadStats();
	}

	//////////////////////////////////////////////////////////
}
